module.exports = __webpack_public_path__ + "img/36.5922d429.jpg";